export function getFirst() {
  try {
    const pdfs = require.context('../assets/cv', false, /\.pdf$/);
    const keys = pdfs.keys();
    if (keys.length === 0) return null;
    return pdfs(keys[0]);
  } catch (e) {
    console.error("Error loading PDFs:", e);
    return null;
  }
}